var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"todo"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Todo list")]),_c('todo-list')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }